import * as React from "react";
import { Link } from "react-router-dom";
import * as cn from "classnames/bind";
import * as styles from "./button.css";

const cx = cn.bind(styles);

const buttonCn = () =>
    cx({
        btn: true,
        button: true,
    });

interface ButtonProps {
    onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
    onMouseLeave?: (e: React.MouseEvent<HTMLElement>) => void;
    onMouseEnter?: (e: React.MouseEvent<HTMLElement>) => void;
    className?: string;
    disabled?: boolean;
    width?: number | string;
    text: string;
    link?: boolean;
    to?: string;
    iconClass?: string;
    iconPlacement?: string;
    style?: React.CSSProperties;
    loading?: boolean;
    loadingText?: string;
}

const Button: React.SFC<ButtonProps> = ({
    text,
    width,
    link = false,
    to = "/",
    className = "",
    children,
    iconClass = null,
    iconPlacement = "left",
    loading,
    loadingText = "Loading...",
    style,
    disabled,
    ...rest
}) =>
    link ? (
        <Link to={to} className={className}>
            {!!iconClass && iconPlacement === "left" && (
                <i className={iconClass} style={{ paddingRight: "5px" }} />
            )}
            {text}
            {!!iconClass && iconPlacement === "right" && (
                <i className={iconClass} style={{ paddingLeft: "5px" }} />
            )}
        </Link>
    ) : (
        <button
            {...rest}
            className={`${buttonCn()} ${className}`.trim()}
            style={style ? { ...style } : { width }}
            disabled={loading || disabled}>
            {loading ? (
                <>
                    <span className={"spinner-border spinner-border-sm"}></span>
                    {loadingText}
                </>
            ) : (
                <>
                    {!!iconClass && iconPlacement === "left" && (
                        <i
                            className={iconClass}
                            style={{ paddingRight: "5px" }}
                        />
                    )}
                    {children}
                    {text}
                    {!!iconClass && iconPlacement === "right" && (
                        <i
                            className={iconClass}
                            style={{ paddingLeft: "5px" }}
                        />
                    )}
                </>
            )}
        </button>
    );

export default Button;
